import {
  IMPLEMENT_PLATE_QUESTION_SLUG,
  VEHICLE_PLATE_QUESTION_SLUG,
} from 'v3/pages/Checklist/Questions/shared/utils';

const IMPLEMENT_SLUGS = new Set([IMPLEMENT_PLATE_QUESTION_SLUG, 'wagon_plate']);

function safeStr(value) {
  if (value === null || value === undefined) return '';
  return String(value);
}

function normalizeText(value) {
  return safeStr(value)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim();
}

function getQuestionPayload(raw) {
  if (raw?.question && typeof raw.question === 'object') return raw.question;
  return raw || {};
}

export function getPlateQuestionSlug(raw) {
  const question = getQuestionPayload(raw);
  const slug = safeStr(
    question?.type?.slug ||
      question?.questionType?.slug ||
      question?.typeSlug ||
      raw?.type?.slug ||
      raw?.questionType?.slug,
  ).toLowerCase();

  if (slug === VEHICLE_PLATE_QUESTION_SLUG) return VEHICLE_PLATE_QUESTION_SLUG;
  if (IMPLEMENT_SLUGS.has(slug)) return 'wagon_plate';

  const label = normalizeText(
    typeof question?.question === 'string'
      ? question.question
      : question?.label || question?.name || raw?.question,
  );

  if (label.includes('placa') && (label.includes('implemento') || label.includes('carroceria'))) {
    return 'wagon_plate';
  }

  if (label.includes('placa') && (label.includes('tracao') || label.includes('veiculo'))) {
    return VEHICLE_PLATE_QUESTION_SLUG;
  }

  return '';
}

export function getQuestionLabel(raw) {
  const question = getQuestionPayload(raw);
  return safeStr(
    typeof question?.question === 'string'
      ? question.question
      : question?.label || question?.name || raw?.question,
  );
}

export function buildTemplatePlateItems(questions = []) {
  return (Array.isArray(questions) ? questions : [])
    .map((raw, index) => {
      const slug = getPlateQuestionSlug(raw);
      if (!slug) return null;

      return {
        key: Number(raw?.id),
        slug,
        label: getQuestionLabel(raw),
        index,
      };
    })
    .filter((item) => item && Number.isInteger(item.key) && item.key > 0);
}

export function buildMissingResponsePlateItems(questions = []) {
  return (Array.isArray(questions) ? questions : [])
    .map((raw, index) => {
      const slug = getPlateQuestionSlug(raw);
      if (!slug) return null;

      const currentPlate =
        slug === VEHICLE_PLATE_QUESTION_SLUG
          ? raw?.vehicle?.plate || (raw?.vehicleId ? raw?.questionDescriptiveResponse : '')
          : raw?.wagon?.plate || (raw?.wagonId ? raw?.questionDescriptiveResponse : '');
      const currentId = slug === VEHICLE_PLATE_QUESTION_SLUG ? raw?.vehicleId : raw?.wagonId;

      if (currentId || safeStr(currentPlate).trim()) return null;

      return {
        key: Number(raw?.id),
        slug,
        label: getQuestionLabel(raw),
        index,
      };
    })
    .filter((item) => item && Number.isInteger(item.key) && item.key > 0);
}

export function toTemplatePlateAnswers(selections = []) {
  return selections.map(({ item, option }) => ({
    checklistQuestionId: item.key,
    ...(item.slug === VEHICLE_PLATE_QUESTION_SLUG
      ? { vehicleId: Number(option.id) }
      : { wagonId: Number(option.id) }),
  }));
}

export function toResponsePlateAnswers(selections = []) {
  return selections.map(({ item, option }) => ({
    questionResponseId: item.key,
    ...(item.slug === VEHICLE_PLATE_QUESTION_SLUG
      ? { vehicleId: Number(option.id) }
      : { wagonId: Number(option.id) }),
  }));
}
